/**
 * Loyalty Level
 */
export const GadgetsLoyaltyLevelFilter = (model: IGadgetsLoyaltyLevelFilter): IGadgetsLoyaltyLevelFilterModel => {
	const { ...rest } = model

	return {
		...rest,
	}
}

/**
 * Partner
 */
export const GadgetsPartnerFilter = (model: IGadgetsPartnerFilter): IGadgetsPartnerFilterModel => {
	const { ...rest } = model

	return {
		...rest,
	}
}

export const GadgetsPartner = (model: IGadgetsPartner): IGadgetsPartnerModel => {
	const { uuid, email, phone_number, logo_media_id, logo, gadgets_count, updated_at, created_at, ...rest } = model

	return {
		...rest,
		uuid,
		email,
		phone: phone_number,
		logoMediaId: logo_media_id,
		logo: logo ? Media(logo) : null,
		gadgetCount: gadgets_count,
		createdAt: created_at ? new Date(created_at) : null,
		updatedAt: updated_at ? new Date(updated_at) : null,
	}
}

const GadgetsPartnerWarehouseAddress = (
	model: IGadgetsPartnerWarehouseAddressFormValues,
): IGadgetsPartnerWarehouseAddressPayload => {
	const { city, postcode, street, buildingNumber, phoneNumber, companyName } = model

	return {
		city,
		street,
		postcode,
		building_number: buildingNumber,
		phone_number: phoneNumber,
		company_name: companyName,
	}
}

const GadgetsPartnerSharedPayload = (
	event: IFormSubmitEvent<IGadgetsPartnerFormValues>,
): IGadgetsPartnerSharedPayload => {
	const { name, email, phone, warehouseAddress } = event.values

	return {
		name,
		email,
		phone_number: phone,
		warehouse_address: warehouseAddress ? GadgetsPartnerWarehouseAddress(warehouseAddress) : null,
	}
}

export const GadgetsPartnerCreateToPayload = (
	event: IFormSubmitEvent<IGadgetsPartnerFormValues>,
): IGadgetsPartnerCreatePayload => {
	const shared = GadgetsPartnerSharedPayload(event)

	return {
		...shared,
	}
}

export const GadgetsPartnerUpdateToPayload = (
	updated: IGadgetsPartnerModel,
	event: IFormSubmitEvent<IGadgetsPartnerFormValues>,
): IGadgetsPartnerUpdatePayload => {
	const shared = GadgetsPartnerSharedPayload(event)

	return {
		...shared,
		id: updated.id,
	}
}
/**
 * Category
 */
export const GadgetsCategoryFilter = (model: IGadgetsCategoryFilter): IGadgetsCategoryFilterModel => {
	const { ...rest } = model

	return {
		...rest,
	}
}

export const GadgetsCategoryFilterDetails = (model: IGadgetsCategory): IGadgetsCategoryModel => {
	const { name, name_trans, gadgets_count, updated_at, created_at, ...rest } = model

	return {
		...rest,
		name: safeLangContentMapper(name),
		nameTrans: name_trans,
		gadgetCount: gadgets_count,
		createdAt: created_at ? new Date(created_at) : null,
		updatedAt: updated_at ? new Date(updated_at) : null,
	}
}

const GadgetsCategorySharedPayload = (
	event: IFormSubmitEvent<IGadgetsCategoryFormValues>,
): IGadgetsCategorySharedPayload => {
	const { name, nameEn, nameUa } = event.values

	const names = {
		pl: name,
		en: nameEn,
		ua: nameUa,
	}

	return {
		name: generateLangContentArrayFromObject(names),
	}
}

export const GadgetsCategoryCreateToPayload = (
	event: IFormSubmitEvent<IGadgetsCategoryFormValues>,
): IGadgetsCategoryCreatePayload => {
	const shared = GadgetsCategorySharedPayload(event)

	return {
		...shared,
	}
}

export const GadgetsCategoryUpdateToPayload = (
	updated: IGadgetsCategoryModel,
	event: IFormSubmitEvent<IGadgetsCategoryFormValues>,
): IGadgetsCategoryUpdatePayload => {
	const shared = GadgetsCategorySharedPayload(event)

	return {
		...shared,
		id: updated.id,
	}
}
